export const orders = {
  title: 'Orders',
  subtitle: 'Order management and tracking',
  
  // Basic information
  list: {
    title: 'Order list',
    empty: 'No orders',
    loading: 'Loading orders...',
    error: 'Error loading orders',
    searchPlaceholder: 'Search by order number, customer name or email...',
    createNew: 'New order',
    createNewSoon: 'New order feature coming soon!'
  },

  // Table headers
  table: {
    number: 'Order number',
    customer: 'Customer',
    date: 'Date',
    status: 'Status',
    amount: 'Amount',
    deliveryNote: 'Delivery note',
    actions: 'Actions'
  },

  // Statuses
  status: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    completed: 'Completed'
  },

  // Actions
  actions: {
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    createDeliveryNote: 'Create delivery note',
    updateStatus: 'Update status'
  },

  // Statistics
  stats: {
    total: 'Total orders',
    pending: 'Pending',
    confirmed: 'Confirmed',
    completed: 'Completed'
  },

  // Status filter
  filter: {
    all: 'All',
    pending: 'Pending',
    confirmed: 'Confirmed',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    completed: 'Completed'
  },

  // Order details
  details: {
    title: 'Order details',
    basicInfo: 'Basic information',
    customerInfo: 'Customer information',
    deliveryInfo: 'Delivery information',
    items: 'Order items',
    paymentInfo: 'Payment information',
    notes: 'Notes',
    systemInfo: 'System information',
    documentChain: 'Document chain'
  },

  // Order editing
  form: {
    title: 'Edit order',
    status: 'Status',
    requestedDeliveryDate: 'Requested delivery date',
    confirmedDeliveryDate: 'Confirmed delivery date',
    deliveryAddress: 'Delivery address',
    deliveryInstructions: 'Delivery instructions',
    paymentTerms: 'Payment terms',
    paymentMethod: 'Payment method',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',
    required: 'required'
  },

  // Payment methods
  paymentMethods: {
    bankTransfer: 'Bank transfer',
    cash: 'Cash',
    card: 'Credit card',
    check: 'Check'
  },

  // Fields
  fields: {
    orderNumber: 'Order number',
    customerName: 'Customer name',
    customerEmail: 'Customer email',
    orderDate: 'Order date',
    totalAmount: 'Total amount',
    subtotal: 'Net amount',
    currency: 'Currency',
    createdAt: 'Created',
    updatedAt: 'Updated',
    createdBy: 'Created by'
  },

  // Messages
  messages: {
    statusUpdated: 'Status updated successfully',
    orderUpdated: 'Order updated successfully',
    orderDeleted: 'Order deleted successfully',
    deliveryNoteCreated: 'Delivery note created successfully',
    confirmDelete: 'Are you sure you want to delete this order?',
    deleteWarning: 'This action cannot be undone!'
  },

  // Errors
  errors: {
    loadFailed: 'Error loading orders',
    updateFailed: 'Error updating order',
    deleteFailed: 'Error deleting order',
    notFound: 'Order not found',
    invalidData: 'Invalid data'
  }
}; 